import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getPlatformChurch,
  getPlatformChurches,
  seedPlatformChurch,
  type PlatformChurchFilters,
} from "@/api/platform";

export function usePlatformChurches(
  filters: PlatformChurchFilters = {}
) {
  return useQuery({
    queryKey: ["platform-churches", filters],
    queryFn: () => getPlatformChurches(filters),
  });
}

export function usePlatformChurch(
  churchId?: string
) {
  return useQuery({
    queryKey: ["platform-church", churchId],
    enabled: !!churchId,
    queryFn: () => getPlatformChurch(churchId!),
  });
}

export function useSeedPlatformChurch(churchId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => seedPlatformChurch(churchId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["platform-church", churchId] });
      await queryClient.invalidateQueries({ queryKey: ["platform-churches"] });
    },
  });
}
